module.exports = __webpack_public_path__ + "img/refer-top-bg.ae2299dc.jpg";